"use client";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
import SearchFilter from "@/components/SearchFilter/SearchFilter";
import SearchResult from "@/components/SearchResult/SearchResult";
import { useSearchParams } from "next/navigation";
import React, { useState } from "react";

function SearchBar() {
  const searchParams = useSearchParams();
  const specificValue = searchParams.get("q") || "";
  const finalSearchValue = decodeURIComponent(specificValue);
  const MAX_VALUE = 1000000000;
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(1000000000);

  const [checkedItems, setCheckedItems] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [checkedNames, setCheckedNames] = useState<
    { id: string; name: string }[]
  >([]);

  const [sortType, setSortType] = useState(0);
  const [sortOrder, setSortOrder] = useState(false);
  const [checkedBrandItems, setCheckedBrandItems] = useState<{
    [key: number]: boolean;
  }>({});
  useState<{ id: string; name: string }[]>([]);
  const [checkedBrandNames, setCheckedBrandNames] = useState<
    { id: string; name: string }[]
  >([]);
  const [filterCount, setFilterCount] = useState<number>(0);

  const Categorykeys = Object.keys(checkedItems)
    .map(Number)
    .filter((key) => checkedItems[key] === true);

  const brandKeys = Object.keys(checkedBrandItems)
    .map(Number)
    .filter((key) => checkedBrandItems[key] === true);

  const categoryNames = Object.keys(checkedNames)
    .map(String)
    .filter((key) => checkedNames[key] === true);
  const brandNames = Object.keys(checkedBrandNames)
    .map(String)
    .filter((key) => checkedBrandNames[key] === true);

  return (
    <div className=" lg:px-16 sm:px-6  px-0 mt-10">
      <BreadCrumb
        className="sm:mx-0 mx-6"
        links={[
          { id: 1, title: "خانه", to: "/" },
          {
            id: 2,
            title: `جستجو برای :  ${
              finalSearchValue === "" ? "همه‌ی محصولات" : finalSearchValue
            } `,
            to: "/search",
          },
        ]}
      />
      <SearchFilter
        minValue={minValue}
        maxValue={maxValue}
        setMinValue={setMinValue}
        setMaxValue={setMaxValue}
        MAX_VALUE={MAX_VALUE}
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
        checkedNames={checkedNames}
        setCheckedNames={setCheckedNames}
        setCheckedBrandItems={setCheckedBrandItems}
        checkedBrandNames={checkedBrandNames}
        setCheckedBrandNames={setCheckedBrandNames}
        checkedBrandItems={checkedBrandItems}
        filterCount={filterCount}
        Categorykeys={Categorykeys}
        sortType={sortType}
        sortOrder={sortOrder}
        setSortType={setSortType}
        setSortOrder={setSortOrder}
      />
      <React.Suspense fallback={<div>Loading...</div>}>
        <SearchResult
          minValue={minValue}
          maxValue={Number(maxValue + 1)}
          Categorykeys={Categorykeys}
          brandKeys={brandKeys}
          filterCount={filterCount}
          setFilterCount={setFilterCount}
          sortType={sortType}
          sortOrder={sortOrder}
          setSortType={setSortType}
          setSortOrder={setSortOrder}
          categoryNames={categoryNames}
          setCheckedNames={setCheckedNames}
          brandNames={brandNames}
          checkedBrandNames={checkedBrandNames}
          setCheckedBrandNames={setCheckedBrandNames}
          checkedItems={checkedItems}
          checkedNames={checkedNames}
          setCheckedItems={setCheckedItems}
          checkedBrandItems={checkedBrandItems}
          setCheckedBrandItems={setCheckedBrandItems}
          setMaxValue={setMaxValue}
        />
      </React.Suspense>
    </div>
  );
}

export default SearchBar;
